module.exports = __webpack_public_path__ + "img/logo-bold-dark.bd8cadac.png";